import type { IconData } from '@stacksjs/iconify-core'

export const gripHorizontalLine: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 11H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m0 4H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default gripHorizontalLine
